import * as actionTypes from '../actions/actionTypes';
import { updateObject } from '../utility';
import ControlStation from '../../helpers/ControlStation';

const initialState = {
    deviceConfig: [],
    userPlan: [],
    userPlanDevice: [],
    controllerStations: [],
    controllerIds: [],
    initControllerIds: false,
    controllerNames: {},
    loading: false,
    finish: false,
    isOwner: "both",
    owner: null
};

const fetchDeviceConfigStart = ( state, action ) => {
    return updateObject( state, { 
        loading: true,
        finish: false,
        deviceConfig: [],
        userPlan: [],
        userPlanDevice: [],
        controllerStations: [],
        controllerNames: {},
        controllerIds: [],
        isOwner: action.isOwner,
        owner: action.owner
    } );
};

const fetchDeviceConfigFail = ( state ) => {
    return updateObject( state, { 
        loading: false ,
        finish: false
    } );
};

const fetchDeviceConfigFinish = ( state ) => {
    return updateObject( state, { 
        finish: true,
        loading: false
    } );
}

const fetchUserPlanFinish = (state) => {
    const data = ControlStation(state.userPlan, state.userPlanDevice, state.deviceConfig);
    let controllerNames = {}
    const dataLength = data.length;
    for(let i = 0 ; i < dataLength; i++) {
        const controllerStation = data[i];
        const controller = controllerStation.controller;
        const splitController = controller.split('-');
        const nameController = splitController[0] !== undefined ? splitController[0] : null;
        controllerNames[controllerStation.controller] = controllerStation.name + " (" + nameController + ")";
    }
    return updateObject( state, { 
        controllerStations: data,
        controllerNames: controllerNames,
        finish: true,
        loading: false
    } );
}

const fetchDeviceConfigSuccess = ( state, action ) => {
    return updateObject( state, { 
        deviceConfig: [
            ...state.deviceConfig,
            ...action.deviceConfig
        ]
    } );
}

const fetchUserPlanDeviceSuccess = ( state, action ) => {
    return updateObject( state, { 
        userPlanDevice: [
            ...state.userPlanDevice,
            ...action.userPlanDevice
        ]
    } );
}

const fetchUserPlanSuccess = ( state, action ) => {
    return updateObject( state, { 
        userPlan: [
            ...state.userPlan,
            ...action.userPlan
        ]
    } );
}

const addControllerStationIds = ( state, action ) => {
    return updateObject( state, { 
        controllerIds: action.controllerIds,
        initControllerIds: true,
    } );
}

const fetchOutletRefresh = ( state ) => {
    return updateObject( state, initialState );
}

const reducer = ( state = initialState, action ) => {
    switch ( action.type ) {
        case actionTypes.FETCH_DEVICE_CONFIG_START: return fetchDeviceConfigStart( state, action );
        case actionTypes.FETCH_DEVICE_CONFIG_FAIL: return fetchDeviceConfigFail( state );
        case actionTypes.FETCH_DEVICE_CONFIG_FINISH: return fetchDeviceConfigFinish( state );
        case actionTypes.FETCH_USER_PLAN_FINISH: return fetchUserPlanFinish( state );
        case actionTypes.FETCH_DEVICE_CONFIG_SUCCESS: return fetchDeviceConfigSuccess( state ,action );
        case actionTypes.FETCH_USER_PLAN_DEVICE_SUCCESS: return fetchUserPlanDeviceSuccess( state ,action );
        case actionTypes.FETCH_USER_PLAN_SUCCESS: return fetchUserPlanSuccess( state ,action );
        case actionTypes.ADD_CONTROLLER_STATION_IDS: return addControllerStationIds( state ,action );
        case actionTypes.FETCH_OUTLET_REFRESH: return fetchOutletRefresh( state );
        default: return state;
    }
};

export default reducer;